import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit, Close as IconClose } from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import RepairForm from "./RepairForm";
import TxtRow from "components/Custom/TxtRow";

import { ApiMasters } from "apihandlers//masters/masters";

import { NOTIFY, DEFAULTS, FORMATS, CONFIG, API_CONFIG } from "common/config";
import { COLORS } from "common/colors";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  TITLES,
  SUB_TITLES,
} from "common/labels";

import { COMMON_JS } from "common/scripts";

import { DateFunctions } from "common/datefunctions";
import TxtBox from "components/Custom/TxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";
import { ApiIndents } from "apihandlers//indent";

const ApiMastersHandler = new ApiMasters();
const ApiIndentsHandler = new ApiIndents();

const thumbnailImg = require("assets/images/pdf.png");

const Repair = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = () => {
    const fromDate = (
      document.getElementById("fromDate") as HTMLInputElement
    ).value.trim();
    const toDate = (
      document.getElementById("toDate") as HTMLInputElement
    ).value.trim();
    const args = {
      // activeStatus: true,
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      fromDate,

      toDate,
    };
    setRows(null);
    ApiMastersHandler.getVehicleMaintenances(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
        console.log("Rows", rows);
        console.log("Selected Row", selectedRow);
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    // setEditRows([]);
    // getUploadedFiles(row.id);
    // setRepairFiles([]);
    console.log("selected row", selectedRow);
  };

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "vehicleNumber",
      name: LABELS.VEHICLE_NO,
      type: "text",
      width: "18%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "workDescription",
      name: LABELS.DESCRIPTION,
      type: "text",
      width: "22%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },

    {
      key: "workedOn",
      name: LABELS.WORK_DATE,
      type: "text",
      width: "18%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "workPlace",
      name: LABELS.WORK_LOCATION,
      type: "text",
      width: "18%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "serialNo",
      name: LABELS.SERIAL_NO,
      type: "number",
      width: "15%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "odometerReading",
      name: LABELS.ODOMETER_READING,
      type: "number",
      width: "15%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
    {
      key: "positionOfTyre",
      name: LABELS.POSITION_OF_TYRE,
      type: "text",
      width: "15%",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE_STATUS,
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      sortable: true,
      searchable: true,
      width: "14%",
      editable: false,
      align: "center",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };
  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
    // setEditRows([]);
    // setRepairFiles([]);
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTIONS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.REPAIR}</li>
        </ul>
        <h4>{TITLES.REPAIRS}</h4>
        <p className="SubTitles">{SUB_TITLES.REPAIRS}</p>
      </div>
      <div id="chartForm">
        <div
          className="formGroup"
          style={{
            display: "flex",
            marginTop: 5,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <label
              style={{
                fontWeight: "500",
                fontSize: 18,
                marginTop: 6,
                marginRight: 10,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtBox
              id={"fromDate"}
              type={"datetime-local"}
              defaultValue={DateFunctions.getDate(
                "lastmonth",
                "to",
                FORMATS.SQL_DATE
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 18,
                marginTop: 6,
                marginRight: 10,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtBox
              id={"toDate"}
              type={"datetime-local"}
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                FORMATS.SQL_DATE
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
            }}
          >
            <Btn text={LABELS.LOAD} onClick={getRows} />
          </div>
        </div>
      </div>
      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.REPAIRS}
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.REPAIRS}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <RepairForm
          selectedRow={selectedRow}
          defaultValues={{}}
          setSelectedRow={setSelectedRow}
          setManageDialog={setManageDialog}
          reloadGrid={reloadGrid}
          onEditRow={onEditRow}
        />
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Repair);
